/**
 * Public access guide (routes from `MEMBERSHIP_ROUTE` in `membershipAccessFlow`).
 * Membership funnel UI is English-only (US/intl Stripe focus).
 */

import type { MembershipFunnelPath } from "@/lib/membershipAccessFlow";
import { MEMBERSHIP_ROUTE } from "@/lib/membershipAccessFlow";

export interface MembershipPortalStepDef {
  path: MembershipFunnelPath;
  title: string;
  body: string;
  cta: string;
  highlight?: boolean;
}

/** Typical sequence after payment. */
export const MEMBERSHIP_PORTAL_STEPS: MembershipPortalStepDef[] = [
  {
    path: MEMBERSHIP_ROUTE.REGISTRO,
    title: "I just paid (any membership plan)",
    body:
      "After payment, the site usually brings you here to create your account. If you closed the tab or don't see the form, open this link and use the same email you paid with.",
    cta: "Create account",
    highlight: true,
  },
  {
    path: MEMBERSHIP_ROUTE.COMPLETAR_REGISTRO,
    title: "I have an account but still need to complete my profile",
    body:
      "Nickname, Telegram, and date of birth. The team needs these before they can review and approve your access.",
    cta: "Complete profile",
  },
  {
    path: MEMBERSHIP_ROUTE.PENDING_APPROVAL,
    title: "I submitted my profile and I'm waiting",
    body:
      "The team reviews your account and payment, then assigns your private access link. This page refreshes automatically once you're approved.",
    cta: "Go to review / waiting room",
  },
  {
    path: MEMBERSHIP_ROUTE.MI_ACCESO,
    title: "I'm already approved",
    body: "Your private access link (Telegram or other channel) appears there.",
    cta: "View my access",
  },
  {
    path: MEMBERSHIP_ROUTE.ENTRAR,
    title: "I just want to sign in",
    body: "If you already have an account and aren't mid sign-up.",
    cta: "Sign in",
  },
];